///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "../helpers/authProvider";
import Spinner from "./icons/Spinner";

const ProtectedRoute = ({
  component: Component,
  render,
  isLoading,
  ...rest
}) => (
  <AuthConsumer>
    {({ isAuthenticated, signinRedirect }) => {
      if (!isAuthenticated()) signinRedirect();
      const guard = isLoading || !isAuthenticated();
      return (
        <Route
          {...rest}
          render={
            render && !isLoading
              ? render
              : props =>
                  guard ? (
                    <div className="spinner-holder">
                      <Spinner
                        className="box-content spinner"
                        height="40px"
                        width="40px"
                        fill="#C9CACC"
                      />
                    </div>
                  ) : (
                    <Component {...props} />
                  )
          }
        />
      );
    }}
  </AuthConsumer>
);
export default ProtectedRoute;
